// frontend/src/components/MlPredict/MlPredictSelector.tsx

import React from 'react';
import type { ModelInfo } from '../../services/mlModels.service';

interface Props {
  models: ModelInfo[];
  selectedAlias: string | null;
  onSelect: (alias: string) => void;
  loading: boolean;
}

export const MlPredictSelector: React.FC<Props> = ({
  models,
  selectedAlias,
  onSelect,
  loading,
}) => {
  if (loading && models.length === 0) {
    return (
      <div className="selector-section">
        <h3>📦 Modelo em Produção</h3>
        <div className="loading-state">Carregando modelos...</div>
      </div>
    );
  }

  if (models.length === 0) {
    return (
      <div className="selector-section">
        <h3>📦 Modelo em Produção</h3>
        <div className="empty-state">Nenhum modelo em produção disponível</div>
      </div>
    );
  }

  return (
    <div className="selector-section">
      <h3>📦 Modelo em Produção</h3>
      <div className="selector-list">
        {models.map((model) => {
          const isSelected = selectedAlias === model.alias;

          return (
            <button
              key={model.alias}
              type="button"
              onClick={() => onSelect(model.alias)}
              className={`model-card ${isSelected ? 'selected' : ''}`}
            >
              <div className="model-card-alias">
                🏷️ {model.alias}
              </div>
              <div className="model-card-name">
                {model.dataset_name}
              </div>
              <div className="model-card-meta">
                {model.model_name} · {model.pipeline_version}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};